<!-- 店铺管理 - 装修公司 -->
<template>
  <div class="boxDiv">
    <el-form>
      
      <el-row>
        <el-col :span="8">
          <el-form-item label="负责人：" style="display: flex; width: 360px">
            <el-input v-model="guanlizheName" placeholder="请输入负责人名字" maxlength="10" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话：" style="display: flex; width: 360px">
            <el-input v-model="guanlizhePhone" placeholder="请输入联系电话" maxlength="11" style="width: 90%"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="店铺描述：" style="display: flex; width: 360px">
            <el-input v-model="miaoshu" placeholder="请输入店铺描述" maxlength="11" style="width: 90%"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="均单价格(万元)：" label-width="60px" style="display: flex; width: 360px">
            <el-input v-model="jundan" placeholder="请输入均单价格·万元" style="width: 90%"
            onkeyup="value=value.replace(/^(\-)*(\d+)\.(\d).*$/,'$1$2.$3')"/>
            <!-- onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="成单数量：" style="display: flex; width: 360px">
            <el-input v-model="customerOrderCount" placeholder="请输入成单数量" maxlength="6" style="width: 90%"
             onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item label="店铺创客收款人：" label-width="120px">
            <el-input v-model="telPhone" style="width:300px" maxlength="11" placeholder="请输入收款人手机号"/><span style="color: #F56C6C;">（收款人手机号必须已登录授权“甄惠装”小程序）</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
            <!-- <el-input type="textarea" v-model="ActivityContent" style="width:650px;"
              :autosize="{ minRows: 2, maxRows: 6}" maxlength="500" show-word-limit/> -->
          <!-- <el-form-item label="到店有礼：">
            <el-switch v-model="yyisOpen" active-color="#138cdd" inactive-color="#999" :change="handleSwitch()" style="margin-right: 10px;"/>
            <el-input v-model="ActivityContent" placeholder="输入礼品名称，不超过10个汉字" maxlength="10" style="width:300px;"/>
            <div class="upload" style="display:block; margin-top: 10px;">
              <el-upload class="avatar-uploader" action :show-file-list="false" :before-upload="beforeCoverOfDecoration">
                <img v-if="coverImageUrlOne" :src="coverImageUrlOne"
                  style="width:172px;height:82px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon" style="margin-left:0px;"></i>
              </el-upload>
              <div style="color:#888;line-height: 10px;">添加礼品图片，限制800*800 px  文件大小不超过1 MB</div>
            </div>
          </el-form-item> -->
        </el-col>
        <el-col :span="12">
          <!-- <el-form-item label="店铺码：" :rules="[ { required: true} ]" label-width="130px">
            <div class="QRCodeClass">
              <div class="dianpuma">
                <img :src="showImageUrl" class="erweima"/> <br>
                <el-button type="primary" size="small" @click="xiazai()">下载店铺码</el-button>
              </div>
              <div class="dianpuma">
                <img :src="staffQRCode" class="erweima"/> <br>
                <el-button type="primary" size="small" @click="xiazaiYg()">下载员工码</el-button>
                <br>
                <el-button type="primary" size="small" @click="choiceRange()">屏蔽店铺</el-button>
              </div>
            </div>
          </el-form-item> -->
        </el-col>
      </el-row>
      

    </el-form>

    <div>
      <p style="height:auto;line-height:11px;text-overflow:ellipsis;white-space: nowrap;">请上传有关店铺的介绍图片:</p>
      <!-- <el-upload
        class="avatar-uploader"
        action
        accept=".png, .jpg"
        :show-file-list="false"
        :before-upload="beforeAvatarUpload"
      >
        <img
          v-if="LogoUrl"
          style="margin-left:20px;margin-top:15px; border-radius: 50%"
          :src="LogoUrl"
          class="avatar"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>-->
      <div style="display:flex;flex-wrap:wrap">
        <div v-for="(item,index) in imgShopArr" :key="index"
          style="display:inline-block; position: relative;">
          <img src="../../assets/img/aicon36.png" @click="deleteimg(index,item)" style="position:absolute;right:-6px;top:3px;width: 20px;" alt/>
          <img :src="item" style="width:240px;height:136px;display:inline-block;margin-top:10px;margin-right:0px;margin-left:14px;"/>
        </div>
        <div class="upload" style="display:inline-block;margin-top:2px">
          <el-upload v-show="isdisabled" v-loading="loading" class="avatar-uploader"
            style action :show-file-list="false" :before-upload="beforeUploadShopIntroduction">
            <img :src="imageUrl2" v-if="imageUrl2" class="avatar" style="width:200px;height:250px;"/>
            <i v-else class="el-icon-plus avatar-uploader-icon" style="margin-left:0px;"></i>
          </el-upload>
        </div>
      </div>
    </div>
    <p style="color:#888;margin-bottom:44px;">建议尺寸：1200*675，支持的图片格式：jpg、png。</p>
  
    <div style="margin-top:10px;height:auto;">
      <p style="height:auto;line-height:11px;text-overflow:ellipsis;white-space: nowrap;">请上传店铺的资质荣耀图片:</p>
      <!-- <el-upload
        class="avatar-uploader"
        action
        accept=".png, .jpg"
        :show-file-list="false"
        :before-upload="beforeAvatarUpload2">
        <img
          v-if="LogoUrl"
          style="margin-left:20px;margin-top:15px; border-radius: 50%"
          :src="LogoUrl"
          class="avatar"/>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>-->
      <div style="display:flex;flex-wrap:wrap">
        <div v-for="(item,index) in imgGloryArr" :key="index"
          style="display:inline-block; position: relative;">
          <img src="../../assets/img/aicon36.png" @click="deleteimg1(index,item)" style="position:absolute;right:-6px;top:3px;width: 20px;" alt/>
          <img :src="item" style="width:240px;height:134px;display:inline-block;margin-right:0px;margin-left:14px;margin-top:10px"/>
        </div>
        <div class="upload">
          <el-upload v-show="isdisabled1" v-loading="loading1" class="avatar-uploader1"
            style action :show-file-list="false" :before-upload="beforeUploadGloryOfQualification">
            <img :src="imageUrl1" v-if="imageUrl1" class="avatar" style="width:500px;height:250px;"/>
            <i v-else class="el-icon-plus avatar-uploader-icon1" style="margin-left:0px;"></i>
          </el-upload>
        </div>
      </div>
    </div>
    <p style="color:#888;">建议尺寸：1200*675，支持的图片格式：jpg、png。</p>

    <div class="bottomBtn">
      <el-button type="danger" @click="emit()">保存</el-button>
      <el-button @click="goback()">返回</el-button>
    </div>
    
    <!-- 选择店铺 -->
    <el-dialog title="选择店铺" :visible.sync="constructionMethod" width="900px" :before-close="handleCloseDialog">
      <div class="chooseDia">
        <div class="searchLeft">
          <p>请选择店铺</p>
          <el-button type="warning" @click="handleSelectAll()">全选</el-button>
        </div>
        <div class="searchRight">
          <div class="searchTop">
            <el-input v-model="searchConpai" placeholder="请输入搜索内容">
              <template slot="append">
                <el-button @click="findinfo()">搜索</el-button>
              </template>
            </el-input>
          </div>
          <div class="searchBot">
            <p style="cursor: pointer;" :class="{brandColor: tmpList.indexOf(item.id) > -1}" ref="styleName"
              v-for="(item,index) in specialtyStyleList" :key="index"
              @click="choosedSpecialty(item,index)">{{item.name}}</p>
            <div v-if="noMoreSorry" style="text-align: center;padding-top: 50px;">不好意思，未搜索到此内容</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="text-align:center;">
          <el-button type="danger" @click="yesConstructionSure()">确认</el-button>
          <el-button @click="noConstruction()">取消</el-button>
        </div>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { uploadOSS } from '../../utils/oss';
import { getOssFile, postAddFile } from '../../api/newOss';
import { getDcHome, putDcHome} from '../../api/activityFormList'
import { canFilterShop, searchShop, shopFilterShop } from "../../api/shopWindow";
export default {
  name: "homepage",
  data() {
    return {
      actionUrl: "",
      LogoUrl: "",
      isdisabled: true,
      loading: false,
      imageUrl2: "",
      imgShopArr: [],
      onePic: [],
      introduce: "", // 店铺介绍
      isdisabled1: true,
      loading1: false,
      imageUrl1: "",
      imgGloryArr: [],
      twoPic: [],
      qualifications: "", // 资质荣耀
      guanlizheName: '', // 负责人
      guanlizhePhone: '', // 联系电话
      miaoshu: '', // 店铺描述
      jundan: '', // 均单价格
      customerOrderCount: 0, // 成单数量
      telPhone: '', // 店铺创客收款人
      yyisOpen: false, // 是否开启店铺有礼
      ActivityContent: "", // 预约有礼
      
      // 礼品图片
      coverImageUrlOne: "",
      coverImageUrlOneQiege: "",
      showImageUrl: "", // 二维码图片

      // 选择店铺
      constructionMethod: false,
      tmpList:[], // 屏蔽店铺临时存放
      specialtyStyleList: [],
      noMoreSorry: false, // 不好意思
      searchConpai: "",
      staffQRCode: '', // 员工二维码
    };
  },
  methods: {
    // 点击-屏蔽店铺
    choiceRange() {
      this.constructionMethod = true;
      this.searchConpai = ""; // 清空关键字
      this.noMoreSorry = false;
      var obj = {
        bbId: localStorage.businessBbId,
        key: this.searchConpai
      };
      canFilterShop(obj).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.noMoreSorry = false;
            this.specialtyStyleList = data.resultObj;
            let sousuoId = {
              bbId: localStorage.businessBbId
            };
            searchShop(sousuoId).then(data => {
              if (data.resultCode == 1) {
                // console.log(data.resultObj,'AAA');
                this.tmpList = data.resultObj.map(item=>item.id);
              }
            });
          } else {
            this.specialtyStyleList = [];
            this.noMoreSorry = true;
          }
        } else {
          this.specialtyStyleList = [];
          this.noMoreSorry = true;
        }
      });
    },
    // 搜索
    findinfo() {
      var obj = {
        bbId: localStorage.businessBbId,
        key: this.searchConpai
      };
      canFilterShop(obj).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.noMoreSorry = false;
            this.specialtyStyleList = data.resultObj;
            let sousuoId = {
              bbId: localStorage.businessBbId
            };
            searchShop(sousuoId).then(data => {
              if (data.resultCode == 1) {
                // console.log(data.resultObj,'AAA');
                this.tmpList = data.resultObj.map(item=>item.id);
              }
            });
          } else {
            this.specialtyStyleList = [];
          }
        } else {
          this.specialtyStyleList = [];
          this.noMoreSorry = true;
        }
      });
      // searchShop(obj).then((data) => {
      //   if (data.resultCode == 1) {
      //     this.brandList = data.resultObj;
      //     this.$nextTick(() => {
      //       for (var i = 0; i < this.$refs.brandName.length; i++) {
      //         this.$refs.brandName[i].style.color = "#606266";
      //         this.$refs.brandName[i].style.background = "#f0f0f0";
      //       }
      //     });
      //     this.$nextTick(() => {
      //       for (var i = 0; i < this.brandList.length; i++) {
      //         for (var k = 0; k < this.Brandarr.length; k++) {
      //           if (this.brandList[i].Id == this.Brandarr[k]) {
      //             this.$refs.brandName[i].style.color = "#fff";
      //             this.$refs.brandName[i].style.background = "#F56C6C";
      //           }
      //         }
      //       }
      //     });
      //   }
      // });
    },
    // 全选
    // handleSelectAll() {
    //   this.tmpList = this.specialtyStyleList.map(item=>item.id);
    // },
    
    // 全选/不选
    handleSelectAll() {
      if (this.tmpList.length == this.specialtyStyleList.length) {
        this.tmpList = [];
      } else {
        this.tmpList = this.specialtyStyleList.map(item=>item.id);
      }
    },
    // 反选
    handleInverseSelect() {
      let all = this.specialtyStyleList.map(item=>item.id);
      let tmp = this.tmpList.map(item=>item)
      this.tmpList = [];
      all.map(item=>{
        if(tmp.indexOf(item) == -1){
          this.tmpList.push(item);
        }
      })
    },

    // 点击-选择店铺
    choosedSpecialty(item, index) {
      if (this.tmpList.indexOf(item.id) > -1) { // 取消选中
        this.tmpList.splice(this.tmpList.indexOf(item.id), 1);
      } else { // 选中
        this.tmpList.push(item.id);
      }
    },
    // 确认 - 屏蔽店铺
    yesConstructionSure() {
      let obj = {
        userId: localStorage.Id, // 操作人id
        bbId: localStorage.businessBbId, // 店铺id
        filterBbId: this.tmpList // 过滤店铺id集合（数组）
      }
      shopFilterShop(obj).then(res => {
        if(res.resultCode == 1) {
          this.$swal({
            type:"success",
            text:"保存成功"
          })
          this.constructionMethod = false; // 隐藏弹框
        }
      })
    },
    // 取消 - 屏蔽店铺
    noConstruction() {
      this.constructionMethod = false; // 取消弹框
    },
    // 关闭弹框
    handleCloseDialog() {
      this.constructionMethod = false; // 屏蔽店铺
    },



    goback() {
      this.$router.go(-1);
      // if (this.$route.query.type == 1) {
      //   this.$router.push({
      //     path: "/companyList"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/companyList",
      //     query: {
      //       type: 2,
      //       pageIndex: this.$route.query.pageIndex,
      //       name: this.$route.query.name,
      //       provinceId: this.$route.query.provinceId,
      //       cityId: this.$route.query.cityId,
      //       statusId: this.$route.query.statusId,
      //       isfind: this.$route.query.isfind
      //     }
      //   });
      // }
    },
    init(val) {
      if(val == 7) {
        this.getInfoById();
      }
    },
    // 查询装修公司基本信息详情
    getInfoById() {
      this.imgShopArr = [];
      this.onePic = [];
      this.imgGloryArr = [];
      this.twoPic = [];
      var obj = {
        userId: localStorage.Id,
        dcId: localStorage.businessBbId
        // operTypeId: 3
      };
      getDcHome(obj).then(data => {
        if (data.resultCode == 1) {
          this.guanlizheName = data.resultObj.contacts; // 联系人
          this.guanlizhePhone = data.resultObj.cPhone; // 联系电话
          this.miaoshu = data.resultObj.notice; // 店铺描述
          this.jundan = data.resultObj.customerOrderAvgPrice==0?'':data.resultObj.customerOrderAvgPrice; // 均单价格
          this.customerOrderCount = Number(data.resultObj.customerOrderCount); // 成单数量
          this.telPhone = data.resultObj.telPhone; // 店铺创客收款人
          for (var i = 0; i < data.resultObj.shopImgList.length; i++) {
            if (data.resultObj.shopImgList[i].fileType == 1) {
              this.imgShopArr.push(data.resultObj.shopImgList[i].filePath);
              this.onePic.push(data.resultObj.shopImgList[i].fileId);
              if (this.imgShopArr.length >= 5) {
                this.isdisabled = false;
              } else {
                this.isdisabled = true;
              }
            } else {
              this.imgGloryArr.push(data.resultObj.shopImgList[i].filePath);
              this.twoPic.push(data.resultObj.shopImgList[i].fileId);
              if (this.imgGloryArr.length >= 20) {
                this.isdisabled1 = false;
              } else {
                this.isdisabled1 = true;
              }
            }
          }
          
          this.yyisOpen = data.resultObj.isStoreGift; // 预约有礼开关
          this.ActivityContent = data.resultObj.storeGift; // 预约有礼
          this.coverImageUrlOne = localStorage.BaseOssUrl + data.resultObj.storeGiftImg; // 店铺有礼图片 - 全链接
          this.coverImageUrlOneQiege = data.resultObj.storeGiftImg; // 店铺有礼图片 - 短连接
          this.showImageUrl = data.resultObj.qrCode; // 店铺码
          this.staffQRCode = data.resultObj.staffQRCode; // 员工二维码
          
        }
      });
    },
    // 保存
    emit() {
      if (this.guanlizheName == ""||this.guanlizheName == null) {
        this.$swal({
          type:"warning",
          text:"请输入负责人名字"
        })
        return false;
      }
      if (this.guanlizhePhone == ""||this.guanlizhePhone == null) {
        this.$swal({
          type:"warning",
          text:"请输入联系电话"
        })
        return false;
      }
      if (this.miaoshu == ""||this.miaoshu == null) {
        this.$swal({
          type:"warning",
          text:"请输入店铺描述"
        })
        return false;
      }
      // if (this.jundan == ""||this.jundan == null) {
      //   this.$swal({
      //     type:"warning",
      //     text:"请输入均单价格·万元（支持2位小数）"
      //   })
      //   return false;
      // }
      // if (Number(this.jundan) < 1) {
      //   this.$swal({
      //     type:"warning",
      //     text:"均单价格需要大于0"
      //   })
      //   return false;
      // }
      if (this.yyisOpen == true && (this.ActivityContent == "" || this.ActivityContent == null)) {
        this.$swal({
          type:"warning",
          text:"请输入礼品名称"
        })
        return false;
      }
      if (this.yyisOpen == true && (this.coverImageUrlOne == "" || this.coverImageUrlOne == null)) {
        this.$swal({
          type:"warning",
          text:"请上传礼品图片"
        })
        return false;
      }
      if (this.onePic.length == 0) {
        this.$swal({
          type: "warning",
          text: "请上传有关店铺的介绍图片"
        });
        return false;
      }
      var obj = {
        // DcId: localStorage.companyId,
        dcId: localStorage.businessBbId, // 店铺id
        contacts: this.guanlizheName, // 联系人
        cPhone: this.guanlizhePhone, // 联系电话
        notice: this.miaoshu, // 店铺描述
        customerOrderAvgPrice: this.jundan, // 均单价格
        customerOrderCount: !Number(this.customerOrderCount)?0:Number(this.customerOrderCount), // 成单数量
        telPhone: this.telPhone, // 店铺创客收款人
        introImgsStr: this.onePic.join(","),
        honorImgsStr: this.twoPic.join(","),
        cOperator: localStorage.Id,
        
        isStoreGift: this.yyisOpen, // 是否开启店铺有礼
        storeGift: this.ActivityContent, // 店铺有礼内容
        storeGiftImg: this.coverImageUrlOneQiege, // 店铺有礼图片
        qrCode: this.showImageUrl, // 店铺码
        
      };
      putDcHome(obj).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: "保存成功"
          });
        }
      });
    },
    deleteimg(index) {
      this.imgShopArr.splice(index, 1);
      this.onePic.splice(index, 1);
      if (this.imgShopArr.length >= 5) {
        this.isdisabled = false;
      } else {
        this.isdisabled = true;
      }
    },
    deleteimg1(index) {
      this.imgGloryArr.splice(index, 1);
      this.twoPic.splice(index, 1);
      if (this.imgShopArr.length >= 20) {
        this.isdisabled1 = false;
      } else {
        this.isdisabled1 = true;
      }
    },
    
    handleSwitch() {
      if(this.yyisOpen == false) {
        this.ActivityContent = '';
        this.coverImageUrlOne = '';
        this.coverImageUrlOneQiege = '';
      }
    },
    // 礼品图片
    beforeCoverOfDecoration(file) {
      const isJPG = file.type
      if (isJPG !='image/jpeg'&&isJPG !='image/png'){
        this.$swal({
          type:"warning",
          text:"上传图片格式应为jpg/png"
        })
        return false
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 800;
        let height = 800;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {
            type: 32
          };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.coverImageUrlOne = newOssPic;
          that.coverImageUrlOneQiege = newOssPic.replace(localStorage.BaseOssUrl,'')

        };
      },() => {
          this.$swal({
            type:"warning",
            text:"上传图片宽高应为800*800"
          })
          return Promise.reject();
        }
      );
      return isSize;
    },
    
    // 店铺介绍
    beforeUploadShopIntroduction(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then( () => {
        var that = this;
        that.loading = true;
        that.imgFlage = true;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {type: 38};
          getOssFile(obj).then(data => {
            that.imgFlage = false;
            that.loading = false;
            this.fileName = file.name;
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.imgShopArr.push(newOssPic);
          that.imgarrCutting = newOssPic.replace(localStorage.BaseOssUrl,'')

          var obj = {
            name: this.fileName,
            url: that.imgarrCutting,
            uploader: localStorage.Id
          };
          postAddFile(obj).then(data => {
            if (data.resultCode == 1) {
              that.onePic.push(data.resultObj);
            }
          });

        };
        if (that.imgShopArr.length >= 4) {
          that.isdisabled = false;
        }

        return file;
      }, () => {
        this.$swal({
          type: "warning",
          text: "上传图片宽高应为1200*675"
        });
        return Promise.reject();
      });
      return isSize;
    },

    // 资质荣耀
    beforeUploadGloryOfQualification(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then( () => {
        var that = this;
        that.loading1 = true;
        that.imgFlage = true;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {type: 39};
          getOssFile(obj).then(data => {
            that.imgFlage = false;
            that.loading1 = false;
            this.fileName = file.name;
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.imgGloryArr.push(newOssPic);
          that.imgarrCutting = newOssPic.replace(localStorage.BaseOssUrl,'')

          var obj = {
            name: this.fileName,
            url: that.imgarrCutting,
            uploader: localStorage.Id
          };
          postAddFile(obj).then(data => {
            if (data.resultCode == 1) {
              that.twoPic.push(data.resultObj);
            }
          });

        };
        if (this.imgGloryArr.length >= 19) {
          this.isdisabled1 = false;
        }
        return file;
      }, () => {
        this.$swal({
          type: "warning",
          text: "上传图片宽高应为1200*675"
        });
        return Promise.reject();
      });
      return isSize;
    },
    
    /**
     * 根据图片路径下载图片
     * @param imgsrc 图片地址
     * @param name 保存的图片名
     */
    downloadImage(imgSrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题,
      image.setAttribute("crossorigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 将图片格式转为base64
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "myPhoto"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgSrc + '?time=' + Date.now();  // 注意，这里是灵魂，否则依旧会产生跨域问题
    },
    // 下载店铺码
    xiazai() {
      let address = this.showImageUrl;
      let intercept = this.showImageUrl.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },
    // 下载员工二维码
    xiazaiYg() {
      let address = this.staffQRCode;
      let intercept = this.staffQRCode.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },
  },
  mounted() {
    // this.actionUrl = localStorage.BaseUrl+
    this.init()
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 240px;
  height: 136px;
  line-height: 136px;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-left: 12px;
  margin-top: 10px;
}
.avatar-uploader1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon1 {
  font-size: 28px;
  color: #8c939d;
  width: 240px;
  height: 134px;
  line-height: 134px;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-left: 12px;
  margin-top: 10px;
}
.boxDiv {
  width: 90%;
  margin-left: 5%;
  padding-top: 10px;
  padding-bottom: 20px;
  margin-top:32px;
}
/* 店铺码 */
.QRCodeClass {
  width: 50%;
  display: flex;
}
.dianpuma {
  width: 180px;
  text-align: center;
  
}
/* 二维码 */
.erweima {
  width: 100px;
  height: 141px;
  margin-bottom: 5px;
}

</style>
<style lang="less" scoped>
.chooseDia {
  width: 740px;
  height: 300px;
  background: #fff;
  border: 1px solid #f6f6f6;
  font-size: 12px;
  margin: auto;
  .searchLeft {
    float: left;
    width: 140px;
    height: 300px;
    color: #797979;
    padding-top: 30px;
    box-sizing: border-box;
    background: #f5f5f5;
    text-align: center;
    p {
      margin-bottom: 20px;
    }
  }
  .searchRight {
    width: calc(100% - 140px);
    float: right;
    height: 300px;
    overflow: hidden;
    text-align: left;
    .searchTop {
      padding: 15px 20px 15px 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #f6f6f6;
      overflow: hidden;
      span {
        display: inline-block;
        cursor: pointer;
        margin: 0 20px 10px 10px;
      }
      /deep/ .el-input {
        width: 240px;
        height: 35px;
        background: #fff;
        margin-top: -10px;
        float: right;
        .el-input__inner {
          height: 35px;
          border: 1px solid #ededed;
        }
      }
      p {
        margin-top: 20px;
        /deep/ .el-input {
          float: none;
          width: 180px;
          height: 35px;
        }
      }
    }
    .searchBot {
      padding: 0 20px 30px 20px;
      box-sizing: border-box;
      max-height: 260px;
      min-height: 65px;
      overflow-y: scroll;
      p {
        display: inline-block;
        // float: left;
        padding: 8px;
        background: #f0f0f0;
        margin-right: 15px;
        margin-bottom: 15px;
      }
    }
  }
}
.brandColor {
  background: #F56C6C !important;
  color: #fff !important;
}

// 底部按钮
.bottomBtn {
  width: 100%;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// homepagezxgs.vue?3825aa9a